export default __webpack_public_path__ + "static/media/customStyles.c94a1d27.png";